import { useCleanConfirmModal } from './CleanConfirmModal';
import { CleanConfirmModal } from './CleanConfirmModal';

CleanConfirmModal.useCleanConfirmModal = useCleanConfirmModal;

export default CleanConfirmModal;